export default __webpack_public_path__ + "static/media/dark-blue-vector.6dbf3df5.png";